import { defineStore } from 'pinia'
import { useAddressStore } from 'src/stores/address'
import { useCartStore } from 'src/stores/cart'
import { isObject } from 'src/utils'
import { encryptStorage } from 'src/utils/pinia-encryption'

export const usePersistedLocalStore = defineStore('persistedLocal', {
  state: () => ({
    isPWAPopupDenied: false,
    cartPersistedInfo: null,
    isCartSectionPined: false,
    filters: {},
    orderFilters: {
      selectedFilter: 'Last 3 Months',
      filterOptions: [],
    },
    showAppDownloadNotification: false,
    disclaimerUpdate: {},
    announcementUpdate: {},
    announcementsRead: false,
    deliveryAddress: null,
    selectedAddress: {},
    subscribeToLNS: false,
    isContactlessdelivery: false,
    uberSandBoxVerifiedCartNumber: null,
    doordashSandBoxVerifiedCartNumber: null,
    persistedCartNumber: null,
  }),
  getters: {
    getCartPersistedInfo() {
      return (cartNumber) =>
        this.cartPersistedInfo && this.cartPersistedInfo[cartNumber]
          ? this.cartPersistedInfo[cartNumber]
          : null
    },
    getFilterByPage() {
      return (page, scopeKey = '') => {
        const scopedPage = scopeKey ? `${page}:${scopeKey}` : page
        // Check if filters exist for the page
        if (this.filters?.[scopedPage] && isObject(this.filters[scopedPage])) {
          return this.filters[scopedPage]
        }

        // Backward compatibility for previously persisted non-scoped filters
        if (this.filters?.[page] && isObject(this.filters[page])) {
          return this.filters[page]
        }

        // Default filter configurations by page type
        const defaultFilters = {
          favorite: {
            sortBy: 0,
            category: '',
            isListView: false,
          },
          wishlist: {
            sortBy: 'Price Low to High',
            isListView: false,
          },
          order: {
            selectedFilter: 'All Orders',
            filterOptions: [],
          },
          'auto-ship-order': {
            filterByStatus: '',
            filterByUpcoming: '',
            StartDate: '',
            EndDate: '',
          },
        }

        // Return page-specific defaults if they exist, otherwise return generic defaults
        return (
          defaultFilters[page] || {
            sortBy: 'Price Low to High',
            pageSize: '10',
            isListView: false,
          }
        )
      }
    },
    selectedAddressForFulfillmentCode() {
      const addressStore = useAddressStore(),
        cartStore = useCartStore()

      return (fulfillmentCode) => {
        let cartDetail = cartStore.currentCartDetails
        let selectedAddress
        // let selectedAddress = state.selectedAddress[fulfillmentCode]
        // if (selectedAddress) {
        //   let addressAvailable = rootGetters['address/getAddressByAddressID'](
        //     selectedAddress.addressId
        //   )
        //   return addressAvailable
        //     ? addressAvailable
        //     : rootGetters['address/defaultAddress']
        // }

        if (cartDetail?.fulfillments) {
          for (let fId in cartDetail.fulfillments) {
            let fulfillment = cartDetail.fulfillments[fId]
            if (
              fulfillment.codeName == fulfillmentCode &&
              fulfillment.addressID
            ) {
              for (let key in addressStore.addresses) {
                if (key == fulfillment.addressID) {
                  selectedAddress = addressStore.addresses[key]
                }
              }
            }
          }
        }

        // return default address
        if (!selectedAddress) selectedAddress = addressStore.defaultAddress
        return selectedAddress
      }
    },
  },
  actions: {
    setField({ field, value }) {
      this[field] = value
    },
    setCartPersistedInfo({ cartNumber, data }) {
      if (cartNumber) {
        if (data) {
          let currentInfo = this.cartPersistedInfo || {}
          this.cartPersistedInfo = {
            ...currentInfo,
            [cartNumber]: {
              ...(currentInfo[cartNumber] || {}),
              ...data,
            },
          }
        } else if (this.cartPersistedInfo) {
          delete this.cartPersistedInfo[cartNumber]
        }
      }
    },
    setFilterByPage({ filter, page, scopeKey = '' }) {
      if (!filter || !page) return
      const scopedPage = scopeKey ? `${page}:${scopeKey}` : page

      this.filters = {
        ...this.filters,
        [scopedPage]: { ...filter },
      }
    },
    clearFilterByPage({ page, scopeKey = '' }) {
      if (!page) return

      const scopedPage = scopeKey ? `${page}:${scopeKey}` : page
      const nextFilters = { ...this.filters }

      if (Object.prototype.hasOwnProperty.call(nextFilters, scopedPage)) {
        delete nextFilters[scopedPage]
      }

      this.filters = nextFilters
    },
    setOrderFilterOptions(filterOptions) {
      this.orderFilters.filterOptions = filterOptions
    },
    setDisclaimerUpdate(disclaimerList) {
      this.disclaimerUpdate = {
        ...this.disclaimerUpdate,
        ...disclaimerList,
      }
    },
    setAnnouncementUpdate(announcementList) {
      this.announcementUpdate = {
        ...this.announcementUpdate,
        ...announcementList,
      }
    },
    setState({ field, value }) {
      if (field) this[field] = value
    },
    setSelectedAddress({ address, fulfillmentCode }) {
      this.selectedAddress = Object.assign({}, this.selectedAddress, {
        [fulfillmentCode]: address,
      })
    },
    removeSubscribeToLNS() {
      delete this.subscribeToLNS
    },
    removeItemSubscription({ cartNumber, orderItemId }) {
      let currentInfo = this.cartPersistedInfo[cartNumber] || {}
      if (
        currentInfo &&
        currentInfo.subscriptionDetails &&
        currentInfo.subscriptionDetails[orderItemId]
      ) {
        delete currentInfo.subscriptionDetails[orderItemId]
      }
    },
  },
  // persist: true,
  persist: {
    storage: encryptStorage,
  },
})
